import React from 'react';
import { clsx } from 'clsx';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'default' | 'lg' | 'xl';
  href?: string;
}
export function Button({
  className,
  variant = 'primary',
  size = 'default',
  href,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-medium transition-colors focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-amber-500/50 disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-amber-700 text-white hover:bg-amber-800 shadow-lg shadow-amber-900/20',
    secondary: 'bg-stone-200 text-stone-900 hover:bg-stone-300',
    outline: 'border-2 border-amber-700 text-amber-900 hover:bg-amber-50',
    ghost: 'text-stone-600 hover:text-stone-900 hover:bg-stone-100'
  };
  const sizes = {
    default: 'h-12 px-6 py-3 text-lg',
    lg: 'h-14 px-8 py-4 text-xl',
    xl: 'h-16 px-10 py-5 text-2xl'
  };
  const combinedClassName = clsx(baseStyles, variants[variant], sizes[size], className);
  if (href) {
    const handleClick = () => {
      // Fire Meta Pixel AddToCart event
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart', {
          content_name: 'Rutinas Doradas - Edición Digital',
          content_ids: ['44816643162166'],
          content_type: 'product',
          value: 9.99,
          currency: 'USD'
        });
      }
    };
    return <a href={href} target="_blank" rel="noopener noreferrer" className={combinedClassName} onClick={handleClick} data-id="element-262">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-263">
      {children}
    </button>;
}